<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'cycle-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>
      <v-card class="pa-3">       
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-subheader class="pl-0">{{ $t('views.fields.cycle.start_date') }}</v-subheader>
            <date-picker
              placeholder="Selecione a data"
              :not-after="startDateBeforeEndDate()"
              v-model="startDate"
              :lang="lang"
              :editable="false"
              format="DD/MM/YYYY"
              clearable></date-picker>
          </v-flex>

          <v-flex xs12 md3>
            <v-subheader class="pl-0">{{ $t('views.fields.cycle.end_date') }}</v-subheader>
            <date-picker
              placeholder="Selecione a data"
              :not-before="startDate"
              v-model="endDate"
              :lang="lang"
              :editable="false"
              :disabled="(!startDate || startDate === '')"
              format="DD/MM/YYYY"
              clearable></date-picker>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md6>
            <v-text-field
              name="name"
              label="Nome do Ciclo"
              v-model="name"></v-text-field>
          </v-flex>
          <v-flex xs12 md4>
            <v-select
              :items="clients"
              v-model="clientId"
              item-text="name"
              item-value="id"
              clearable
              :disabled="clients.length === 0"
              label="Selecione um cliente">
            </v-select>
          </v-flex>
          <v-flex xs12 md2>
            <v-select
              :items="activeOptions"
              v-model="active"
              item-text="description"
              item-value="value"
              label="Status do Ciclo">
            </v-select>
          </v-flex>  
        </v-layout>
        <v-layout>
          <v-flex xs12 md12 text-md-center>
            <v-btn flat color="primary" @click="search()">
              <v-icon>search</v-icon>
              Pesquisar
            </v-btn>
          </v-flex>        
        </v-layout>
      </v-card>
      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.name }}
          </td>
          <td>
            {{ props.item.client.name }}
          </td>
          <td>
            {{ props.item.start_date | prDate }}
          </td>
          <td>
            {{ props.item.end_date | prDate }}
          </td>
          <td>
            <v-tooltip top v-if="props.item.note" class="mouse-over">
              <v-icon slot="activator" dark color="primary">info</v-icon>
              <span>{{ props.item.note }}</span>
            </v-tooltip>
            <span v-if="!props.item.note">Sem observação</span>
          </td>
          <td>
            {{ props.item.qtd_hours }}
          </td>
          <td>
            {{ props.item.active === 'sim' ? 'ATIVO' : 'INATIVO' }}
          </td>
          <td class="text-xs-center">

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id, 'o clico selecionado')">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import moment from 'moment';
import DatePicker from 'vue2-datepicker';
import CrudMixin from '@/components/mixins/CrudMixin';
import CycleService from '@/features/cycle/CycleService';
import ClientService from '@/features/client/ClientService';

export default {
  name: 'cycle-list',
  mixins: [CrudMixin],
  components: {
    DatePicker,
  },
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      activeOptions: [
        { description: 'ATIVO', value: 'sim' },
        { description: 'INATIVO', value: 'nao' },
        { description: 'TODOS', value: null },
      ],
      lang: 'pt-br',
      loader: null,
      endDate: null,
      startDate: null,
      clientId: null,
      active: 'sim',
      name: null,
      clients: [],
      headers: [
        {
          text: this.$t('attributes.name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.client.name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.cycle.start_date'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.cycle.end_date'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.cycle.note'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.cycle.qtd_hours'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.cycle.status'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
      clientService: new ClientService(),
    };
  },
  created() {
    this.loadCombos();
  },
  methods: {
    initCrud() {
      this.serviceType = CycleService;
      this.routerName = 'cycle';
    },
    applyFilters(filter) {
      const params = {
        name: this.name,
        active: this.active,
        client_id: this.clientId,
        start_date: this.startDate,
        end_date: this.endDate,
      };
      return Object.assign(filter, params);
    },
    async loadCombos() {
      this.clients = await this.clientService.query();
    },
    startDateBeforeEndDate() {
      let dateEnd = null;
      if (this.endDate && this.endDate !== '') {
        dateEnd = moment(this.endDate).toDate();
      }
      return dateEnd;
    },
  },
};
</script>
<style>
  .mouse-over {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/features/cycle/CycleList.vue